import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Rating,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const EditUserModal = ({ open, handleClose, handleSubmit, userData }) => {
  const [formData, setFormData] = useState({
    role: "",
    nickname: "",
    email: "",
    fullName: "",
    isActive: false,
    id: null,
    skillLevels: [],
  });

  useEffect(() => {
    if (userData) {
      setFormData({
        role: userData.role,
        nickname: userData.nickname,
        email: userData.email,
        fullName: userData.fullName,
        isActive: userData.isActive,
        id: userData.id,
        skillLevels: userData.skillLevels,
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleRatingChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => {
      const skillIndex = prevState.skillLevels.findIndex(skill => skill.category === name);
  
      if (skillIndex !== -1) {
        const updatedSkills = [...prevState.skillLevels]; 
        updatedSkills[skillIndex] = {
          ...updatedSkills[skillIndex],
          level: Number(value),
        };
  
        return {
          ...prevState,
          skillLevels: updatedSkills,
        };
      }  
      return prevState;
    });
  };
  

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} >
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Edit User</Typography>
          <div>
            <TextField
              id="nickname"
              label="Name"
              name="nickname"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.nickname}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <TextField
              id="fullName"
              label="Full Name"
              name="fullName"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.fullName}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <TextField
              id="email"
              label="Email"
              name="email"
              variant="outlined"
              type="email"
              fullWidth
              value={formData.email}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <FormControl fullWidth>
              <InputLabel>Role</InputLabel>
              <Select
                id="role"
                name="role"
                label="role"
                value={formData.role || ""}
                onChange={handleChange}
              >
                <MenuItem value={"Admin"}>Admin</MenuItem>
                <MenuItem value={"User"}>User</MenuItem>
              </Select>
            </FormControl>
          </div>
          {formData.skillLevels && formData.skillLevels.map((level) => (
            <div key={level.category}>
              <Typography component="legend">{level.category}</Typography>
              <Rating
                size="large"
                name={level.category}
                value={level.level}
                onChange={handleRatingChange}
              />
            </div>
          ))}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserModal;
